import React from 'react';
import {
    StyledSelectorDrawer, StyledBackButton, SelectedHeaderContent,
    SelectorDrawerHeader, SelectorDrawerSave, SelectorDrawerList,
    StyledDrawerItem, DrawerItemName, DrawerItemImageWrapper, DrawerItemImageContainer,
    DrawerItemImage, StyledDrawerItemContainer, DrawerCheckedImage, StyledDrawerItemWrapper
} from './SelectorDrawerStyle';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import checked from '../../../assets/checked.png';
import { APP_CONSTANTS } from 'src/consumer/constants';

export const renderDrawerItems = (drawerItems, selectedDrawerItems, handleOnClick) => {
    return (<StyledDrawerItemContainer>
        {drawerItems?.map((item) => {
            const isSelected = selectedDrawerItems?.includes(item?.id);
            return (
                <StyledDrawerItemWrapper key={item?.id}>
                    <StyledDrawerItem isSelected={isSelected} onClick={() => handleOnClick(item)}>
                        <div>
                            {item?.title && <DrawerItemName>
                                {item?.title}
                            </DrawerItemName>}
                            {item?.subtitle && <DrawerItemName altText>
                                {item?.subtitle}
                            </DrawerItemName>}
                            {isSelected && <DrawerCheckedImage
                                src={checked}
                            />}
                        </div>
                        {item?.icon && <DrawerItemImageWrapper>
                            <DrawerItemImageContainer>
                                <DrawerItemImage icon={APP_CONSTANTS.MEDIA_URL + item?.icon} />
                            </DrawerItemImageContainer>
                        </DrawerItemImageWrapper>}
                    </StyledDrawerItem>
                </StyledDrawerItemWrapper>
            );
        })}
    </StyledDrawerItemContainer>);
}

const SelectorDrawer = (props) => {
    const { isDrawerOpen, handleOnBackClick, drawerItems, drawerInfo, selectedDrawerItems, handleOnClick, handleOnSave, localizedContent } = props;

    return <StyledSelectorDrawer anchor='bottom' open={isDrawerOpen}>
        <SelectorDrawerHeader>
            <StyledBackButton>
                <ArrowBackIosNewIcon onClick={handleOnBackClick} />
            </StyledBackButton>
            <SelectedHeaderContent>
                {drawerInfo?.title}
            </SelectedHeaderContent>
            <SelectorDrawerSave onClick={() => { handleOnSave(selectedDrawerItems, drawerInfo.id); handleOnBackClick(); }}>
                {localizedContent?.save || 'Save'}
            </SelectorDrawerSave>
        </SelectorDrawerHeader>
        <SelectorDrawerList>
            {renderDrawerItems(drawerItems, selectedDrawerItems, handleOnClick)}
        </SelectorDrawerList>
    </StyledSelectorDrawer>
}

export default SelectorDrawer;